import axios from 'axios'

import { type Locale } from '@lib/language'
import { type CartDiscountUpdateResponse, type CartGetResponse } from './types'

interface ValidateVatIdResponse {
  vatId: string
  isValid: boolean
  error?: string | Error
  countryCode?: string
  vatNumber?: string
}

/**
 * Gets Shopify cart by calling an API route.
 */
export const getShopifyCart = async (locale: Locale, cartId: string) => {
  const cartGetResponse = await axios.get<CartGetResponse>(
    '/api/shopify/cart-get',
    {
      params: {
        cart_id: cartId,
      },
      headers: {
        'Content-Type': 'application/json',
        'X-Locale': locale,
      },
    },
  )

  if (cartGetResponse.data?.error || !cartGetResponse.data?.cart) {
    throw new Error(cartGetResponse.data.error ?? 'Unknown error')
  }

  return cartGetResponse.data.cart
}

/**
 * Updates Shopify cart discount by calling an API route.
 */
export const updateShopifyCartDiscount = async (
  locale: Locale,
  cartId: string,
) => {
  const cartDiscountUpdateResponse =
    await axios.get<CartDiscountUpdateResponse>(
      '/api/shopify/cart-discount-update',
      {
        params: {
          cart_id: cartId,
        },
        headers: {
          'Content-Type': 'application/json',
          'X-Locale': locale,
        },
      },
    )

  if (
    cartDiscountUpdateResponse.data?.error ||
    !cartDiscountUpdateResponse.data?.cart
  ) {
    throw new Error(cartDiscountUpdateResponse.data.error ?? 'Unknown error')
  }

  return cartDiscountUpdateResponse.data.cart
}

/**
 * Validates VAT ID by calling an API route.
 */
export const validateVatId = async (vatId: string) => {
  const validateVatIdResponse = await axios.get<ValidateVatIdResponse>(
    '/api/tax/validate-vat-id',
    {
      params: {
        id: vatId,
      },
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return validateVatIdResponse.data
}
